import type React from 'react';
import { Typography } from '@mui/material';
import { ContentWrapper, PageWrapper, SubtitleWrapper } from './styles';
import { type BoxProps, type ContainerProps } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import WithHelpBar from 'src/shared/components/HelpBar/WithHelpBar';
import { Helmet } from 'react-helmet';

type PageWithTitleProps = {
  title: string;
  pageWrapperProps?: ContainerProps;
  contentWrapperProps?: BoxProps;
  children: React.ReactNode;
  titleContent?: React.ReactNode;
  subTitleContent?: React.ReactNode;
  withHelpBar?: boolean;
};

export const PageWithTitle = ({
  title,
  children,
  contentWrapperProps,
  pageWrapperProps,
  titleContent,
  subTitleContent,
  withHelpBar = false
}: PageWithTitleProps) => {
  return (
    <PageWrapper maxWidth="xl" {...pageWrapperProps}>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Grid2 lg={withHelpBar ? 9 : 12} container justifyContent="space-between">
        <Grid2>
          <Typography variant="h1">{title}</Typography>
        </Grid2>
        <Grid2>{titleContent}</Grid2>
      </Grid2>
      {subTitleContent && <SubtitleWrapper>{subTitleContent}</SubtitleWrapper>}
      {withHelpBar ? (
        <WithHelpBar>
          <ContentWrapper $withHelpBar {...contentWrapperProps}>
            {children}
          </ContentWrapper>
        </WithHelpBar>
      ) : (
        <ContentWrapper $withHelpBar={false} {...contentWrapperProps}>
          {children}
        </ContentWrapper>
      )}
    </PageWrapper>
  );
};
